/**
 * Build version name.
 */
import {Enumeration} from './model/enumeration.model';

export class Build implements Enumeration {

  private static ALL_VALUES: { [name: string]: Build } = {};

  public static readonly RELEASE = new Build(0, 'release');
  public static readonly BETA = new Build(1, 'beta');
  public static readonly ALPHA = new Build(2, 'alpha');
  public static readonly PATCH = new Build(3, 'patch');

  private constructor(readonly id: number, readonly name: string) {
    Build.ALL_VALUES[id] = this;
  }
}
